import React from "react";
import { withNamespaces } from "react-i18next";
import { Skeleton } from '@mui/material';
import CardTotals from "../../Home/components/CardTotals";

function CountCard(props) {

    const [cards, setCards] = React.useState([])

    function addComma(numero) {
        return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function prepareCards() {
        let _cards = [];
        props.config.map((conf) => {
            let card = null;
            props.data.map((d) => {
                if (conf.id == d[conf.key]) {
                    card =
                        <CardTotals
                            image={conf.image}
                            xl={conf.xl}
                            md={conf.md}
                            sm={conf.sm}
                            total={addComma(d[conf.keyTotal])}
                            title={d.CardName}
                            propertiesIcon={conf.propertiesIcon}
                            propertiesTitle={conf.propertiesTitle}
                            colorClass={conf.colorClass}
                        />

                    // <div className={conf.classCard}><div style={{
                    //     borderRadius: '1.5rem',
                    //     backgroundColor: conf.color,
                    //     // marginRight: '10px', marginLeft: '10px'
                    // }} className={"shadow card flex-row align-items-center align-items-stretch border-0 "}>
                    //     {props.loading ?
                    //         <Skeleton height={80} width="30%" />
                    //         :
                    //         <div className={conf.propertiesIcon}>
                    //             {conf.icon}
                    //         </div>

                    //     }
                    //     {props.loading ?
                    //         <Skeleton height={80} width="70%" className="margin_left" /> :
                    //         <div className={conf.propertiesTitle}>
                    //             <div className={conf.titleClass}>{d.CardName}</div>
                    //             <div className={conf.totalClass}>{addComma(d[conf.keyTotal])}</div>
                    //         </div>
                    //     }
                    // </div></div>
                }
            })
            if (card != null) {
                _cards.push(card);
            }
        })
        setCards(_cards);
    }
    React.useEffect(() => {
        if (props.data && props.data.length > 0 && props.config && props.config.length > 0) {
            prepareCards();
        }

    }, [props.config, props.data])

    return (<div className="row">
        {cards}
    </div>);
}

export default withNamespaces()(CountCard);